
import { defineComponent, reactive, toRefs } from "vue";
import { userStore } from "@/store/index";
export default defineComponent({
  name: "bottom",
  setup() {
    const store = userStore();
    const data = reactive({
      cmsDetail: store.cmsDetail,
      url: "public/img/icons/favicon-16x16.png"
    });

    return {
      ...toRefs(data)
    };
  }
});
